import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Subscriber, Observable } from 'rxjs';
import { LoaderProvider } from '../loader/loader';
import { App, NavController, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { LoginModel, PrivateProfile, UserProvider } from '../user/user';
import { AppDetectorProvider } from '../detector/detector';
import { GlobalUtil } from '../../tracker/global-utils';

/*
  Generated class for the SessionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SessionProvider {
  public profile: PrivateProfile = null;
  public isLoged: boolean = false;
  constructor(
    public http: HttpClient,
    private storage: Storage,
    private loadingCtrl: LoaderProvider,
    private toastCtrl: ToastController,
    private app: App,
    private translate: TranslateService,
    private detector: AppDetectorProvider
  ) {
    console.log('[session.ts] constructor');
  }

  requestPageSub: Subject<any> = new Subject();
  requestPageProfileEdit: Subject<any> = new Subject();
  requestLoggedIn: Subject<any> = new Subject();
  requestLogout: Subject<any> = new Subject();

  public getToken(first: boolean = false, profileRequired: boolean = true): Promise<string> {
    console.log('getToken()');
    return new Promise((resolve, reject) => {

      let key = (this.detector.isHellaApp()) ? "tokenID" + GlobalUtil.getInstance().currentEventID : "token";

      // let key = (this.detector.isHellaApp()) ? "token" : "token";

      this.storage.get(key).then(token => {
        if (token || first) {
          if (profileRequired) {
            if (!this.checkUserProfile() && !first && !this.detector.isHellaApp()) {
              this.loadingCtrl.dismissAll();
              this.requestPageProfileEdit.next();
              this.toastCtrl
                .create({
                  message: this.translate.instant('PRIVATEPROFILE_FILL_THE_FORM_FIRST'),
                  showCloseButton: true,
                  duration: 3000
                })
                .present();
            } else {
              resolve(token);
            }
          } else {
            resolve(token);
          }
        } else {
          this.loadingCtrl.dismissAll();
          this.requestPageSub.next();
          this.toastCtrl
            .create({
              message: this.translate.instant('LOGIN_HAVE_TO_LOGIN'),
              showCloseButton: true,
              duration: 3000
            }).present();
        }
      });
    });
  }

  public getTokenAndNavigate(first: boolean = false, profileRequired: boolean = true): Promise<string> {
    return new Promise((resolve, reject) => {
      let key = (this.detector.isHellaApp()) ? "tokenID" + GlobalUtil.getInstance().currentEventID : "token";

      this.storage.get(key).then(token => {
        if (token || first) {
          if (profileRequired) {
            if (!this.checkUserProfile() && !first && !this.detector.isHellaApp()) {
              this.loadingCtrl.dismissAll();
              this.requestPageProfileEdit.next();
              this.toastCtrl
                .create({
                  message: this.translate.instant('PRIVATEPROFILE_FILL_THE_FORM_FIRST'),
                  showCloseButton: true,
                  duration: 3000
                })
                .present();
            } else {
              resolve(token);
            }
          } else {
            resolve(token);
          }
        } else {
          this.loadingCtrl.dismissAll();
          this.requestPageSub.next({ resolve: resolve });
          this.toastCtrl
            .create({
              message: this.translate.instant('LOGIN_HAVE_TO_LOGIN'),
              showCloseButton: true,
              duration: 3000
            }).present();
        }
      });
    });
  }

  public checkUserProfile(): boolean {
    if (
      this.profile !== null &&
      (!this.profile.forName || this.profile.forName.length === 0 || !this.profile.surName || this.profile.surName.length === 0)
    ) {
      return false;
    }
    return true;
  }

  public onTriggerPageProfileEdit() {
    this.requestPageProfileEdit.next();
  }

  public onRequestPageLogin(): Subject<any> {
    return this.requestPageSub;
  }

  public onRequestPageProfileEdit(): Subject<any> {
    return this.requestPageProfileEdit;
  }

  public onRequestLoggedIn(): Subject<any> {
    return this.requestLoggedIn;
  }

  public onRequestLogout(): Subject<any> {
    return this.requestLogout;
  }

  saveLogin(model: LoginModel, sufix: string = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.storage
          .set('loginModel' + sufix, model)
          .then(() => { }, err => { })
          .catch(() => { });
        resolve(null);
      } catch (e) {
        console.log(e);
      }
    });
  }
  deleteLogin(){
    this.storage.remove('loginModel')
  }

  isOrganizer(){
    return this.profile && (this.profile.status.toLocaleUpperCase().includes("VER") || this.profile.status.toLocaleUpperCase().includes("ORG"))? true: false;
  }

  sendLoggedIn() {
    this.requestLoggedIn.next();
  }

  sendLogout() {
    this.requestLogout.next();
  }

getLogin(sufix: string = ""): Promise<LoginModel> {
    return new Promise((resolve, reject) => {
      this.storage.get('loginModel' + sufix).then(model => {
        resolve((model || { email: '', password: '' }) as LoginModel);
      });
    });
  }

  getLoginStatus(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      resolve(this.isLoged);
    })
  }
}



// WEBPACK FOOTER //
// /src/providers/session/session.ts